var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoImageBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44601 0.492287C6.10742 -0.0156091 5.4212 -0.152853 4.9133 0.185745L0.492286 3.13309C-0.0156096 3.47169 -0.152853 4.1579 0.185744 4.6658L3.13309 9.08681C3.47169 9.59471 4.1579 9.73195 4.6658 9.39336C5.17369 9.05476 5.31094 8.36854 4.97234 7.86065L3.26544 5.3003C5.26227 5.56679 7.1293 6.20406 8.59748 7.18285C10.5533 8.4867 11.7895 10.3761 11.7895 12.8947C11.7895 13.5052 12.2843 14 12.8947 14C13.5052 14 14 13.5052 14 12.8947C14 9.51867 12.2889 6.98709 9.82365 5.3436C8.23485 4.2844 6.3295 3.58662 4.33197 3.23L6.13947 2.025C6.64737 1.6864 6.78461 1.00018 6.44601 0.492287Z",
    fill: "#C9C9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoImageBack);
export default __webpack_public_path__ + "static/media/ico_image_back.e4f866d5ed7829c1d1b8580a4b010bf0.svg";
export { ForwardRef as ReactComponent };